const dateOptionsConfig = {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  weekday: 'short'
};

export default dateOptionsConfig;
